export const ADMIN_ROLES = Object.freeze({
  ADMIN: "ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN",
  CUSTOMER_SERVICE: "CUSTOMER_SERVICE",
  SALES: "SALES",
});

export type AdminRole = (typeof ADMIN_ROLES)[keyof typeof ADMIN_ROLES];
